import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import ExpressionContainer from './components/ExpressionContainer';
import OperatorCarousel from './components/OperatorCarousel';
import CustomDragLayer from './components/CustomDragLayer';
import MyExpressions from './components/MyExpressions';
import ExpressionPreview from './components/ExpressionPreview';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

const API_URL = process.env.REACT_APP_API_ROOT || 'http://localhost:4000';

const Operators = () => {
    const [expression, setExpression] = useState([]);
    const [history, setHistory] = useState([]);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    // updateExpression can accept either a new value or an updater function.
    const updateExpression = (updaterOrNewValue) => {
        // Save the current state before making changes.
        setHistory(prev => [...prev, expression]);
        if (typeof updaterOrNewValue === 'function') {
            setExpression(prev => updaterOrNewValue(prev));
        } else {
            console.log('Updating expression:', updaterOrNewValue);
            setExpression(updaterOrNewValue);
        }
    };

    const handleSave = async () => {
        const token = await getAccessTokenSilently();
        console.log("Saving expression:", expression);
        
        axios.post(`${API_URL}/api/simulations/expression`, { data: expression }, {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		}).then(response => {
            console.log("Expression saved:", response.data);
        }).catch(error => {
            console.error("Error saving expression:", error);
            if (error.response.status === 401) {
                if (!isAuthenticated) {
                    alert('You are not authorized to save an expression. Please login and try again.');
                } else {
                    alert("You don't have permission to save an expression.");
                }
                
            }
        });
        setExpression([]); // Update the state to reflect the saved expression
    };

    const handleClear = () => {
        setHistory([]);
        setExpression([]);
        console.log('Expression cleared');
    };

    useEffect(() => {
        const handleUndo = () => {
            if (history.length > 0) {
                const previousState = history[history.length - 1];
                setHistory(prev => prev.slice(0, prev.length - 1));
                setExpression(previousState);
                console.log('Undo performed');

            }
        };
        const keyHandler = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                event.preventDefault();
                handleUndo();
            }
        };
        window.addEventListener('keydown', keyHandler);
        return () => window.removeEventListener('keydown', keyHandler);
    }, [history, expression]);

    return (
        <Box sx={{ p: 2, width: '95%', mx: 'auto' }}>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <MyExpressions expression={expression} updateExpression={updateExpression} />
                </Grid>
                <Grid item xs={6}>
                    {/* Expression builder container with buttons moved into ExpressionContainer */}
                    <ExpressionContainer 
                        expression={expression} 
                        updateExpression={updateExpression}
                        onSave={handleSave}
                        onClear={handleClear}
                    />
                    {/* Carousel with operator cards */}
                    <Box sx={{ mt: 4 }}>
                        <OperatorCarousel updateExpression={updateExpression} expression={expression} />
                    </Box>
                    
                </Grid>
                <Grid item xs={3}>
                    <ExpressionPreview expression={expression} />
                </Grid>
            </Grid>
            {/* Custom drag layer for animated preview */}
            <CustomDragLayer />
        </Box>
    );
};

export default Operators;